















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import TableForm from '@/components/common/TableForm.vue'
import $Api from '@api'
import { finalize } from 'rxjs/operators'
import { DateTime } from '@/utils/filters'

@Component({
    components: {
        TableForm
    }
})
export default class SearchDialog extends Vue {
    dateTime = DateTime
    @Prop() title!: string
    @Prop() isShownDialog!: boolean
    @Prop() data: any

    form = {
        current: 1,
        size: 10,
        bvn: '',
        phone: '',
        name: ''
    }

    loading = false
    selectedList: any[] = []
    tableData = []
    tableLoading = false

    get disabled() {
        return this.selectedList.length !== 1
    }

    @Emit('close')
    handleClose() {
        this.tableData = []
        this.resetForm()
    }

    onOpen() {
        if (this.data) {
            this.form.name = this.data.name
        }

        this.getData()
    }

    onSelectionChange(val: any) {
        this.selectedList = val
    }

    resetForm() {
        this.form.name = ''
        this.form.bvn = ''
        this.form.phone = ''
    }

    search() {
        if (this.form.phone || this.form.bvn) {
            this.form.name = ''
        } else {
            this.form.name = this.data.name
        }
        this.getData()
    }

    confirm() {
        this.loading = true
        const [order] = this.selectedList
        if (!order) {
            return
        }
        const params = {
            cameraId: order.cameraId,
            lid: order.lid,
            name: order.name,
            phone: order.phone,
            id: this.data.id
        }
        // console.log(JSON.stringify(params, null, 3))
        $Api.receiptService.bindingSubmit(params)
            .pipe(
                finalize(() => {
                    this.loading = false
                })
            )
            .subscribe(res => {
                this.$message.success(this.$t('common.successs') as string)
                this.$emit('bind-success')
                this.handleClose()
            }, err => {
                this.$message.error(err.message)
            })
    }

    getData() {
        this.tableLoading = true
        $Api.receiptService.getBindingList({ ...this.form })
            .pipe(
                finalize(() => {
                    this.tableLoading = false
                })
            )
            .subscribe(res => {
                this.tableData = res
            })
    }
}
